import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "q-mb-sm" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Report generated:")
], -1)
const _hoisted_2 = { class: "q-mb-sm" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "q-mb-none" }, "Click here to download", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, _mergeProps(_ctx.$attrs, { onClick: _ctx.download }), {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.data.fileName), 1),
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_label, { caption: "" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16, ["onClick"]))
}